import { locales, pathnames } from '@/i18n/i18n.config';

export function checkActivePathname(href: string, currentPath: string): boolean {
    // The locale prefix must be matched on a segment boundary: a bare `startsWith('/de')` also
    // matches routes whose first segment merely begins with a locale code — `/deals` was read as
    // locale `de` + `als`, so the deals item never highlighted. `/events` would break on `en` the
    // same way. Slice rather than `replace`, which would also strip a locale-like substring
    // occurring later in the path.
    const pathLocale = locales.find((locale) => currentPath === `/${locale}` || currentPath.startsWith(`/${locale}/`));
    const pathWithoutLocale = pathLocale ? currentPath.slice(`/${pathLocale}`.length) : currentPath;
    const pathname =
        Object.keys(pathnames).find((pathnameKey) =>
            Object.values(pathnames[pathnameKey]).find((p) => p === pathWithoutLocale)
        ) ||
        pathWithoutLocale ||
        '/';
    return (href !== '/' && pathname.length !== href.length && pathname.startsWith(href)) || pathname === href;
}
